module.exports = __webpack_public_path__ + "static/media/push_black_on.2de03159.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/push_black_on.svg
// module id = 74
// module chunks = 0